// Reads the Rails-emitted `csrf-token` meta tag
// (app/views/layouts/application.html.erb's `csrf_meta_tags`) so a plain
// HTML `<form>` can carry a valid `authenticity_token` without any
// axios/Inertia CSRF plumbing. The sign-in and sign-out controls both need
// a real browser POST — the former for `omniauth-rails_csrf_protection` to
// verify and for Google's top-level redirect to return to a fresh
// document, the latter for the same forgery-protection guarantee — so
// neither goes through Inertia's request layer.
export function csrfToken(): string {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')

  return meta?.content ?? ""
}
